/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heading_About_HighlightInputs */

const en_heading_about_highlight = /** @type {(inputs: Heading_About_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`me`)
};

const ar_heading_about_highlight = /** @type {(inputs: Heading_About_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عني`)
};

const bn_heading_about_highlight = /** @type {(inputs: Heading_About_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আমাকে`)
};

const de_heading_about_highlight = /** @type {(inputs: Heading_About_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mich`)
};

const es_heading_about_highlight = /** @type {(inputs: Heading_About_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mí`)
};

const fr_heading_about_highlight = /** @type {(inputs: Heading_About_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`moi`)
};

const pt_heading_about_highlight = /** @type {(inputs: Heading_About_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mim`)
};

const zh_heading_about_highlight = /** @type {(inputs: Heading_About_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于我`)
};

const tr_heading_about_highlight = /** @type {(inputs: Heading_About_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ben`)
};

const ru_heading_about_highlight = /** @type {(inputs: Heading_About_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`обо мне`)
};

const pl_heading_about_highlight = /** @type {(inputs: Heading_About_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mnie`)
};

/**
* | output |
* | --- |
* | "me" |
*
* @param {Heading_About_HighlightInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const heading_about_highlight = /** @type {((inputs?: Heading_About_HighlightInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heading_About_HighlightInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_heading_about_highlight(inputs)
	if (locale === "bn") return bn_heading_about_highlight(inputs)
	if (locale === "de") return de_heading_about_highlight(inputs)
	if (locale === "es") return es_heading_about_highlight(inputs)
	if (locale === "fr") return fr_heading_about_highlight(inputs)
	if (locale === "pt") return pt_heading_about_highlight(inputs)
	if (locale === "zh") return zh_heading_about_highlight(inputs)
	if (locale === "tr") return tr_heading_about_highlight(inputs)
	if (locale === "ru") return ru_heading_about_highlight(inputs)
	if (locale === "pl") return pl_heading_about_highlight(inputs)
	return en_heading_about_highlight(inputs)
});